import axios from 'axios';
angular.module('leanlaw').factory('netDocsStatusService', ['$q', 'alerts', '$state', 'leanLawAuth', function ($q, alerts, $state, leanLawAuth) {
  const state = {
    netDocsConnected: false,
    isDisconnectedUnintentionally: false,
    loadingNetDocsStatus: false
  };
  let pendingCheck = null;
  const domain = `${leanLawAuth.domain}/v1`;
  function checkStatus() {
    if (pendingCheck) return pendingCheck;
    state.loadingNetDocsStatus = true;
    const deferred = $q.defer();
    pendingCheck = deferred.promise;
    axios.get(`${domain}/documents/status`).then(function (response) {
      const {
        connected,
        isDisconnectedUnintentionally
      } = response.data || {};
      state.netDocsConnected = connected;
      state.isDisconnectedUnintentionally = isDisconnectedUnintentionally;
      deferred.resolve(true);
    }, function (error) {
      alerts.error(error);
      deferred.resolve(false);
    }).finally(function () {
      state.loadingNetDocsStatus = false;
      pendingCheck = null;
    });
    return deferred.promise;
  }
  return {
    state,
    checkStatus
  };
}]);